<script setup lang="ts">
import { computed } from 'vue';
import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';
import Tab from 'primevue/tab';
import TabList from 'primevue/tablist';
import TabPanel from 'primevue/tabpanel';
import TabPanels from 'primevue/tabpanels';
import Tabs from 'primevue/tabs';
import ConfigurationRoleTable from './ConfigurationRoleTable.vue';

const props = defineProps<{
  air_configuration: any;
  configurationRole: any;
  destination_configuration: any;
  flight_rule_configuration: any;
  gateway_configuration: any;
  gate_duration_configuration: any;
  hotel_configuration: any;
  loading: any;
  tour_combination_configuration: any;
  tour_detail_configuration: any;
}>();

const emits = defineEmits<{
  'update:configurationRole': [value: any];
  'update:air_configuration': [value: any];
  'update:hotel_configuration': [value: any];
  'update:gateway_configuration': [value: any];
  'update:destination_configuration': [value: any];
  'update:flight_rule_configuration': [value: any];
  'update:gate_duration_configuration': [value: any];
  'update:tour_combination_configuration': [value: any];
  'update:tour_detail_configuration': [value: any];
}>();

const userAuthorizationsStore = useUserAuthorizationsStore();
const authorizations: any = userAuthorizationsStore.permissionByRole;

const configuration_role = computed({
  get() {
    return props.configurationRole;
  },
  set(value) {
    emits('update:configurationRole', value);
  }
});

const air_configuration = computed({
  get() {
    return props.air_configuration;
  },
  set(value) {
    emits('update:air_configuration', value);
  }
});

const hotel_configuration = computed({
  get() {
    return props.hotel_configuration;
  },
  set(value) {
    emits('update:hotel_configuration', value);
  }
});

const gateway_configuration = computed({
  get() {
    return props.gateway_configuration;
  },
  set(value) {
    emits('update:gateway_configuration', value);
  }
});

const destination_configuration = computed({
  get() {
    return props.destination_configuration;
  },
  set(value) {
    emits('update:destination_configuration', value);
  }
});

const flight_rule_configuration = computed({
  get() {
    return props.flight_rule_configuration;
  },
  set(value) {
    emits('update:flight_rule_configuration', value);
  }
});

const gate_duration_configuration = computed({
  get() {
    return props.gate_duration_configuration;
  },
  set(value) {
    emits('update:gate_duration_configuration', value);
  }
});

const tour_combination_configuration = computed({
  get() {
    return props.tour_combination_configuration;
  },
  set(value) {
    emits('update:tour_combination_configuration', value);
  }
});

const tour_detail_configuration = computed({
  get() {
    return props.tour_detail_configuration;
  },
  set(value) {
    emits('update:tour_detail_configuration', value);
  }
});
</script>
<template>
  <div class="card">
    <Tabs :value="0">
      <TabList>
        <Tab :key="0" :value="0">{{ $t('role.general') }}</Tab>
        <Tab :key="1" :value="1">{{ $t('role.air_management') }}</Tab>
        <Tab :key="2" :value="2">{{ $t('role.hotel_management') }}</Tab>
        <Tab :key="3" :value="3">{{ $t('role.package_management') }}</Tab>
        <Tab :key="4" :value="4">{{ $t('role.tour_management') }}</Tab>
      </TabList>
      <TabPanels>
        <TabPanel :key="0" :value="0"><ConfigurationRoleTable :typeRoleHeader="$t('role.permission')" :configurationRoleManagement="configuration_role" :roleUpdateEdit="authorizations?.configurationPage?.role_update_edit" /></TabPanel>
        <TabPanel :key="1" :value="1"><ConfigurationRoleTable :typeRoleHeader="$t('role.permission')" :configurationRoleManagement="air_configuration" :roleUpdateEdit="authorizations?.configurationPage?.role_update_edit" /></TabPanel>
        <TabPanel :key="2" :value="2"><ConfigurationRoleTable :typeRoleHeader="$t('role.permission')" :configurationRoleManagement="hotel_configuration" :roleUpdateEdit="authorizations?.configurationPage?.role_update_edit" /></TabPanel>
        <TabPanel :key="3" :value="3">
          <h5>{{ $t('role.gateway_management') }}</h5>
          <ConfigurationRoleTable :typeRoleHeader="$t('role.permission')" :configurationRoleManagement="gateway_configuration" :roleUpdateEdit="authorizations?.configurationPage?.role_update_edit" />
          <h5>{{ $t('role.destination_management') }}</h5>
          <ConfigurationRoleTable :typeRoleHeader="$t('role.permission')" :configurationRoleManagement="destination_configuration" :roleUpdateEdit="authorizations?.configurationPage?.role_update_edit" />
          <h5>{{ $t('role.flight_rules_management') }}</h5>
          <ConfigurationRoleTable :typeRoleHeader="$t('role.permission')" :configurationRoleManagement="flight_rule_configuration" :roleUpdateEdit="authorizations?.configurationPage?.role_update_edit" />
          <h5>{{ $t('role.duration_management') }}</h5>
          <ConfigurationRoleTable :typeRoleHeader="$t('role.permission')" :configurationRoleManagement="gate_duration_configuration" :roleUpdateEdit="authorizations?.configurationPage?.role_update_edit" />
        </TabPanel>
        <TabPanel :key="4" :value="4">
          <h5>{{ $t('role.gateway_destination_management') }}</h5>
          <ConfigurationRoleTable :typeRoleHeader="$t('role.permission')" :configurationRoleManagement="tour_combination_configuration" :roleUpdateEdit="authorizations?.configurationPage?.role_update_edit" />
          <h5>{{ $t('role.tour_detail_management') }}</h5>
          <ConfigurationRoleTable :typeRoleHeader="$t('role.permission')" :configurationRoleManagement="tour_detail_configuration" :roleUpdateEdit="authorizations?.configurationPage?.role_update_edit" />
        </TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>
